export function cleanDiacritics(inputString: string): string {
  return inputString.normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "");
}
export function cleanForeignLetters(inputString: string): string {
  const foreignLettersMap: Record<string, string> = { Ø: "O", ø: "o" };
  return inputString.replaceAll(
    /[^A-Za-z]/g,
    (char) => foreignLettersMap[char] ?? char,
  );
}
